import { analytics } from '../Firebase'

export const Play_Stats = (
  game_id,
  game_type,
  a_c,
  a_i,
  a_m,
  t_s,
  t_e,
  p_e,
  s_e
) => {
  // console.log('play_stats', {
  //     game_id : game_id,
  //     game_type : game_type,
  //     answers_correct : a_c,
  //     answers_incorrect : a_i,
  //     answers_missed : a_m,
  //     tokens_spent : t_s,
  //     tokens_earned : t_e,
  //     points_earned : p_e,
  //     stars_earned : s_e,
  // })
  analytics.logEvent('play_stats', {
    game_id: game_id,
    game_type: game_type,
    answers_correct: a_c,
    answers_incorrect: a_i,
    answers_missed: a_m,
    tokens_spent: t_s,
    tokens_earned: t_e,
    points_earned: p_e,
    stars_earned: s_e,
  })
}



// WEBPACK FOOTER //
// src/Agent/GoogleAnalytics.js